import script from "./Agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./Agreement.vue?vue&type=script&setup=true&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=ce9c1a3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9c1a3c"]])

export default __exports__